<div class="task-completed">
  <h2>{{ 'share-milestone.task-completed' | translate }}</h2>
  <h1>{{ 'share-milestone.thank-you' | translate }}</h1>
</div>
